import { useFrame } from '@react-three/fiber'
import { useRef } from 'react'
import {
  DEFAULT_HYSTERESIS,
  estimateFps,
  nextTier,
} from '../config/quality'
import { useExperienceStore } from '../store/experienceStore'

export function AdaptiveQuality() {
  const samples = useRef<number[]>([])
  const lowStreak = useRef(0)
  const highStreak = useRef(0)
  const acc = useRef(0)

  useFrame((_, dt) => {
    const fps = dt > 0 ? 1 / dt : 60
    samples.current.push(fps)
    if (samples.current.length > 60) samples.current.shift()

    acc.current += dt
    if (acc.current < 0.5) return
    acc.current = 0

    const state = useExperienceStore.getState()
    if (state.qualityLocked) return

    const avg = estimateFps(samples.current)
    const result = nextTier(
      state.quality,
      avg,
      DEFAULT_HYSTERESIS,
      lowStreak.current,
      highStreak.current,
    )
    lowStreak.current = result.lowStreakSec
    highStreak.current = result.highStreakSec
    if (result.tier !== state.quality) {
      state.setQuality(result.tier)
    }
  })

  return null
}
